import { Link, Stack, Text } from '@fluentui/react';
import logo from '../../images/wtw-logo.png'
import { Image } from '@fluentui/react/lib/Image';
import NavBar from '../login/NavBar';
import styles from './Header.module.scss'
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import { ChatMode } from '../../enums/ChatMode';
import Constants from '../../constants/Constansts';

const Header = () => {
    const location = useLocation();
    const [chat_mode,] = useState<ChatMode>(location.state as ChatMode);
    return (
        <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
            <Link href="/" className={styles.headerLink}>
                <Image src={logo} height={35} width={70} alt="wtw.ai logo" />
            </Link>

            <Text className={styles.headerTitle} >{Constants.ChatModeLabels[chat_mode]} </Text>

            <NavBar />
        </Stack>
    );
};

export default Header;